<!-- <div class="wrapper" [matMenuTriggerFor]="userNotificationsMenu"> -->
<a
  routerLink="/my-messages"
  class="wrapper"
  (click)="onMessagesClick($event)"
  [ngClass]="{ external }"
>
  <ng-icon name="featherBell" size="20"></ng-icon>
  <div class="count" *ngIf="newMessagesCount && newMessagesCount > 0">
    {{ newMessagesCount }}
  </div>
</a>

<!-- <mat-menu #userNotificationsMenu="matMenu">
  <div class="notifications-dropdown">
    <div class="title">My messages:</div>
it

    <div class="items">
      <div class="item">
        <span>You received a new message from John Doe.</span>
      </div>
      <div class="item">
        <span>You received a new message from John Doe.</span>
      </div>
      <div class="item">
        <span>You received a new message from John Doe.</span>
      </div>
    </div>
  </div>
</mat-menu> -->
